import React from 'react';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../../../AbstractElements';
import AnimatedCheckboxButtonsClass from './AnimatedCheckboxButtons';
import AnimatedClass from './AnimatedClass';
import CustomCheckboxClass from './CustomCheckbox';
import CustomRadioClass from './CustomRadio';
import SquareCheckboxClass from './SquareCheckbox';

const CheckboxandRadio = () => {
  return (
    <Container fluid={true}>
      <Breadcrumbs pageTitle='Checkbox & Radio' parent='Form Controls' title='Checkbox & Radio' />
      <Row>
        <CustomRadioClass />
        <CustomCheckboxClass />
        <SquareCheckboxClass />
        <AnimatedClass />
        <AnimatedCheckboxButtonsClass />
      </Row>
    </Container>
  );
};

export default CheckboxandRadio;
